import { getFeatureToggleClient } from 'misc/featureToggles'

export function isHideDocumentsSectionPageButtonToggleEnabled() {
  return getFeatureToggleClient().variation(
    'CustomerPortal.HideDocumentsSectionPageButton',
    false
  )
}
